// extracted by mini-css-extract-plugin
export default {"logo":"_P8KIy"};